// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1M78f","productName":"Table_productName__1WH4L"};